module.exports = __webpack_public_path__ + "img/视频封面5.c7c50c69.png";